import './../css/main.sass'
import './partials/navbar.js'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'

import 'jquery-ui/ui/widgets/datepicker.js'
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/datepicker.css'
import 'jquery-ui/themes/base/theme.css'

import '../../node_modules/babel-polyfill'
import '../../node_modules/client-oauth2'
import { getRequestToken, refreshToken } from '../js/oauth2/authenticate.js'

import Vue from 'vue/dist/vue.esm'

let store = {
    state: {
        trigger: {
            refreshed_token: 0,
            section_header: 'Mein Bereich',
            view: 'dashboard',
            loading: false
        },
        user_data: {
            cardnumber: null,
            cashbackpoints: null,
            held_back_cashbackpoints: null,
            transactions_log: [],
            new_mail: null,
            invalid_new_mail_response: null,
            valid_mail: false,
            reseted_email: false,
        },
        parking_processes:{
            processes: [],
            current_day: null,
            current_day_formatted: null,
            days: [],
        },
        transaction_data: {
            current_day: null,
            current_day_formatted: null,
            days: [], 
        },
        user_pin: {
            old_pin: null,
            new_pin: null,
            new_repeated_pin: null,
            invalid_old_pin_response_message: null,
            invalid_new_pin_response_message: null,
            invalid_new_repeated_pin_response_message: null,
        },
        set_user_data_response_message: null,
        set_user_pin_response_message: null,
        invalid_submitted_data: false,
        user_has_parken_plus: true,
        user_info: {},     
    },

    //function to set user data
    setUserData(json){
        this.state.user_data.cardnumber = json.card.number;
        this.state.user_data.cashbackpoints = json.card.amount_in_points + json.card.frozen_amount_in_points;
        this.state.user_data.held_back_cashbackpoints = json.card.frozen_amount_in_points;

        // replace strings with the value of null with real null to enable placeholder
        if(json !== undefined){
            for(let key in json){
                if(json[key] === 'null'){
                    json[key] = null;
                }
            }
        }

        this.state.user_info = json;
        let chunks = this.state.user_info.date_of_birth.split('-');
        this.state.user_info.date_of_birth = chunks[2] + '.' + chunks[1] + '.' + chunks[0];
    },

    // function to set and order parking processes by date 
    setDataParkingProcesses(processes){
        let monthsAdded = [];

        let formattedProcesses = [];

        if(processes.length > 0){
            let days = [];
            let map = {};

            for(let i = 0; i < processes.length; i++){

                let short = parseInt(processes[i].completed_at.split('T')[0].replace(/-?/g, ""));

                if(!days.includes(short)){days.push(short);}

                let date = new Date(processes[i].completed_at);
                const property = date.getMonth() + "-" + date.getFullYear();
                map[property] = map[property] || 0;
                map[property] += processes[i].amount_in_cents;
            }

            days.sort((a,b) => b - a)
            
            for(let i = 0; i < days.length; i++) {
                let day = days[i].toString();
                days[i] = day.substring(0,4) + '-' + day.substring(4,6) + '-' + day.substring(6,8);
            }

            for(let i = 0; i < days.length; i++){
                let processCollection = [];
                let day = {};              

                for(let j = 0; j < processes.length; j++){
                    let pShort = processes[j].completed_at.split('T')[0];
                    if(pShort == days[i]) {
                        processCollection.push(processes[j]);
                    }
                }

                day.date = days[i];
                day.processes = processCollection;
                let monthDate = new Date(days[i]);
                let mapKey = monthDate.getMonth() + "-" + monthDate.getFullYear();
                if (!monthsAdded.includes(mapKey)) {
                    day.monthSum = {
                        name: monthDate.toLocaleDateString('de-DE', { year: 'numeric', month: 'long' }),
                        sum: map[mapKey]
                    }
                    monthsAdded.push(mapKey);
                }
                formattedProcesses.push(day);
            }

            this.state.parking_processes.days = days;
        }
        this.state.parking_processes.current_day = formattedProcesses[0].date;
        this.state.parking_processes.processes = formattedProcesses;
        this.state.trigger.loading = false;
        
    },

    // function to set and order transactions by date 
    setDataTransactions(transactions){

        let formattedTransactions = [];
        let dates = [];
        let shortDates = [];

        // collect all dates in response
        for (let i = 0; i < transactions.length; i++) {
            let short = transactions[i].created_at.split('T')[0];
            if (!shortDates.includes(short)) {
                shortDates.push(short);
                dates.push(transactions[i].created_at);
            }
        }

        // rearrange json object for vue loop
        for (let i = 0; i < shortDates.length; i++) {
            let date = shortDates[i];
            let day = {};
            let currentTransactions = [];
        
            // collect all transactions for this day
            for (let j = 0; j < transactions.length; j++) {
                let sd = transactions[j].created_at.split('T')[0]                    
              if (sd == date) {
                currentTransactions.push(this.determineSourceTarget(transactions[j]));
              }
            }
        
            day.date = date;
            day.transactions = currentTransactions;
        
            formattedTransactions.push(day);
        }
        this.state.user_data.transactions_log = formattedTransactions;
        this.state.transaction_data.current_day = formattedTransactions[0].transactions[0].created_at;
        this.state.trigger.loading = false;
    },

    // function to change data based on an incoming or outgoing transaction 
    determineSourceTarget(transaction){
        let source = transaction.source;
        if(source.hasOwnProperty('card')){
            // get name if target is a business
            if(transaction.target == null){
                transaction.name = '-';
            } else {
                transaction.name = transaction.target.name;
            }
            // convert positive values to negative values
            transaction.amount_in_cents = ~transaction.amount_in_cents + 1;
            transaction.amount_in_points = ~transaction.amount_in_points + 1;
            transaction.bonus_portion_amount_in_cents = ~transaction.bonus_portion_amount_in_cents + 1;
            transaction.bonus_portion_amount_in_points = ~transaction.bonus_portion_amount_in_points + 1;

        } else {
            if(transaction.source == null){
                transaction.name = '-';
            } else {
                transaction.name = transaction.source.name;
            }
        }
        return transaction;
    }

}

let dashboard = new Vue({
    el: '#user-dashboard',
    data: store.state,      
    methods: {
        // function to manage what section gets displayed
        manageView: function (target_view){
            this.trigger.view = target_view;
            this.setHeadline(target_view);
            
            switch(target_view){
                case 'transactions':
                    this.trigger.loading = true;
                    this.fetchTransactions();
                    break;
                case 'parken-plus':
                    this.trigger.loading = true;
                    this.fetchParkingProcesses();
            }
        },

        // function to dertermine headline of the current view
        setHeadline: function (target_view){
            let headline = '';
            switch(target_view) {
                case 'dashboard':
                    headline = 'Mein Bereich';
                    break;
                case 'ratingen-card':
                    headline = 'Meine RatingenCard';
                    break;
                case 'parken-plus':
                    headline = 'Mein Parken';
                    break;
                case 'pin':
                    headline = 'Meine PIN';
                    break;
                case 'transactions':
                    headline = 'Meine Transaktionen';
                    break;
                case 'personal-data':
                    headline = 'Meine persönlichen Daten';
                    break;
            }
            this.trigger.section_header = headline;
        },

        // function to scroll to a specific day in transactions
        scrollToDay() {
            if(this.transaction_data.current_day != null){
                let transactions = this.user_data.transactions_log;
                let chunks = this.transaction_data.current_day.split('/');
                let date = chunks[2] + chunks[0] + chunks[1];
                let avaliableDate = transactions[0].date.replace(/-?/g, "");
                
                for(let i = 0; i < transactions.length; i++){
                    let dateAsNumberTarget = parseInt(transactions[i].date.replace(/-?/g,""));
                    if(dateAsNumberTarget == parseInt(date)){
                        avaliableDate = dateAsNumberTarget;
                        break;
                    } else if (dateAsNumberTarget < parseInt(avaliableDate) && dateAsNumberTarget > parseInt(date)) {
                        avaliableDate = dateAsNumberTarget;
                    }        
                }
                avaliableDate = avaliableDate.toString();
                let result = avaliableDate.substring(0, 4) + '-' + avaliableDate.substring(4, 6) + '-' + avaliableDate.substring(6, 8);
                let elem = $('#'+result);
                
                $('html, body').animate({ scrollTop: elem.position().top + 200 }, "slow");
            }
        },

        // function to scroll to a specific day in parking processes
        scrollToParkingDay(){
            if(this.parking_processes.current_day != null){
                let processes = this.parking_processes.days;
                let date = this.parking_processes.current_day.replace(/-?/g, "");
                let avaliableDate = processes[0].replace(/-?/g,"");

                for(let i = 0; i < processes.length; i++){
                    let dateAsNumberTarget = parseInt(processes[i].replace(/-?/g, ""));
                    if(dateAsNumberTarget == parseInt(date)){
                        avaliableDate = dateAsNumberTarget;
                        break;
                    } else if(dateAsNumberTarget < parseInt(avaliableDate) && dateAsNumberTarget > parseInt(date)){
                        avaliableDate = dateAsNumberTarget;
                    }
                }
                
                avaliableDate = avaliableDate.toString();
                let result = avaliableDate.substring(0,4) + '-' + avaliableDate.substring(4,6) + '-' + avaliableDate.substring(6,8);
                let elem = $('#'+result);
                let add = $(window).height() / 2;
                
                $('html, body').animate({ scrollTop: elem.offset().top - add }, "slow");

            }
        },

        // function to open and close transactions
        collapseTransaction: function(id){
            if($("#collapsible_" + id).hasClass('bold-me')){
                $("#collapsible_" + id).removeClass('bold-me');
            } else {
                $("#collapsible_" + id).addClass('bold-me');
            }

            let el = $('#'+id);            
            el.collapse('toggle');
        },

        // function to format date for transactions subheadline
        formattedDate: function(date, bool){
            let mlist = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
            let dlist = ["Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa.", "So."];            
            
            let source = new Date(date);
            let target = source.getDate() + '. ' + mlist[source.getMonth()] + ' ' + source.getFullYear();
            
            if(bool) {                
                return dlist[source.getDay()] + ', ' + target;
            } else {
                return target;
            }
            
        },

        // function to return formatted time string from date
        timeOfDateTime(date){
            let source = new Date(date);
            // get two digit hour if < 10
            let hours = ("0" + source.getHours()).slice(-2);
            let minutes = ("0" + source.getMinutes()).slice(-2);
            return hours + ':' + minutes + ' Uhr';
        },

        // function to format cashbackpoints to euro (€)
        cashbackToEuro: function (cashBackPoints) {
            let euro = 0.01 * cashBackPoints;
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(euro);
        },

        // function to format cashbackpoints
        formattedPoints: function(points){
            if(points == null){points = 0;}
            let euro = 0.01 * parseFloat(points);
            let value = points + ' Punkte ' + ' (' + new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(euro) + ')';
            return value;
        },

        // function to format overall cashbackpoints
        formattedPointsMinusBonus: function(points, bonusPoints){
            if(points == null){points = 0};
            if(bonusPoints == null){bonusPoints = 0};
            let sum = parseFloat(points) - parseFloat(bonusPoints);
            let euro = 0.01 * sum;            
            let value =  sum + ' Punkte ' + ' (' + new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(euro) + ')';
            return value;
        },

        // jquery datepicker config for transactions
        datePick: function (){
            let that = this;
            let today = new Date();
            $("#datepicker").datepicker({
                beforeShow: function(){
                    $("#datepicker-indicator img").addClass('open-indicator')
                },
                maxDate: today,
                onSelect: function (date, inst) {
                    that.transaction_data.current_day = $("#datepicker").val();
                    that.transaction_data.current_day_formatted = that.formattedDate($("#datepicker").val(), true);
                    
                    $(this).val(that.transaction_data.current_day_formatted);
                    
                    that.scrollToDay();
                },
                onClose: function(){
                    $("#datepicker-indicator img").removeClass('open-indicator')
                }             
            }).focus(); 
        },

        // jquery datepicker config for parking processes
        datePickParking: function (){
            let that = this;
            let today = new Date();
            $("#datepickerParking").datepicker({
                beforeShow: function(){
                    $("#datepicker-indicator img").addClass('open-indicator')
                },
                maxDate: today,
                onSelect: function (date, inst) {
                    let chunks = $("#datepickerParking").val().split('/');
                    that.parking_processes.current_day = chunks[2] + '-' + chunks[0] + '-' + chunks[1];
                    that.parking_processes.current_day_formatted = that.formattedDate($("#datepickerParking").val(), true);
                    
                    $(this).val(that.parking_processes.current_day_formatted);
                    that.scrollToParkingDay();
                },
                onClose: function(){
                    $("#datepicker-indicator img").removeClass('open-indicator')
                }             
            }).focus(); 
        },

        formatCurrencyCentsToEuro: function(value){
            return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value/100);
        },

        // function to handle api response errors and refresh accessToken for second attempt
        async handleErrorResponse(error, _function) {
            // store temp counter for second switch
            let temp = this.trigger.refreshed_token;
            // switch for error response general
            switch(error.status){
                case 400:
                    if(this.trigger.refreshToken > 0){
                        this.redirectToIndex();
                    }
                    break;
                case 422:
                    if(_function == 'pin'){
                        this.set_user_pin_response_message = "Die von Ihnen angegebene ursprüngliche PIN ist nicht korrekt."
                    }
                    break;
            }

            // check if accessToken got refreshed
            if(temp == 0 && error.status == 401) {
                // set counter 
                this.trigger.refreshed_token = this.trigger.refreshed_token +1;
                // refresh token
                try {
                    await refreshToken();
                } catch (e) {
                    return new Promise(e);
                };              
                
                
                // switch case to rerun fetch 
                switch(_function){
                    case 'user-info':                        
                        this.fetchUserInfo();
                        break;
                    case 'pin':
                        this.fetchIndividualPin();
                        break;
                    case 'parking-processes':
                        this.fetchParkingProcesses();
                        break;
                    case 'transactions':
                        this.fetchTransactions();
                        break;
                    case 'personal-data':
                        this.submitPersonalData()
                        break;
                    case 'personal-data-email':
                        this.finalSubmitPersonalDataEmail('yes');
                        break;         
                }
            } else if(this.trigger.refreshed_token > 0){
                this.redirectToIndex();
            }
        },

        // function to redirect user to the index page 
        redirectToIndex() {
            localStorage.removeItem('ClientOAuth2Token');
            window.location.href = 'index.html';            
        },
        
        // function to fetch users base data 
        fetchUserInfo() {
            //get OAuth2 token
            let token = getRequestToken();            
            let header = token.sign({
                method: 'GET',
                url: process.env.NEW_BACKEND_BASE_URL + "/apis/web/v1/profile"
            })
            // fetch with OAutch2
            fetch(header.url, {
                method: header.method,
                headers: header.headers
            })
            .then(response => {
                //reject not 200(HTTP-Statuscode) response
                if(!response.ok){
                    return Promise.reject(response)
                }
                return response.json()
            })
            //catch error response
            .catch(async response => {
                const error = await response
                return Promise.reject(error)
            })
            .then(json => {
                // process data after successful fetch
                this.trigger.refreshed_token = 0
                store.setUserData(json)
            }
            )
            .catch(error => 
                // process error after unsuccessful fetch   
                this.handleErrorResponse(error, 'user-info')
            )
        },

        // function to fetch transactions from api
        fetchTransactions() {
            //get OAuth2 token
            let token = getRequestToken();            
            let header = token.sign({
                method: 'GET',
                url: process.env.NEW_BACKEND_BASE_URL + "/apis/web/v1/profile/transactions"
            })
            //fetch with OAuth2
            fetch(header.url, {
                method: header.method,
                headers: header.headers
            })
            .then(response => {
                //reject not 200(HTTP-Statuscode) response
                if(!response.ok){
                    return Promise.reject(response)
                }
                return response.json()
            })
            // catch error response
            .catch(async response => {
                const error = await response
                return Promise.reject(error)
            })
            .then(async json => {
                // process data after successful fetch
                this.trigger.refreshed_token = 0
                // some IDE's will critize this await (leave it)
                if(json.length > 0) {
                    await store.setDataTransactions(json)
                    this.setStartVariables(); 
                } else {
                    this.trigger.loading = false;
                }            
            })
            .catch(error => 
                // process error after unsuccessful fetch
                this.handleErrorResponse(error, 'transactions')
            )
        },

        // function to initially set the input value of the date select
        setStartVariables(){
            if(this.transaction_data.current_day != null){
                this.transaction_data.current_day_formatted = this.formattedDate(this.transaction_data.current_day, true);
                document.getElementById("datepicker").value = this.transaction_data.current_day_formatted;
            }

        },

        // function to initially set the input value of the date select
        setStartVariablesParkingProcesses(){
            if(this.parking_processes.current_day != null){
                this.parking_processes.current_day_formatted = this.formattedDate(this.parking_processes.current_day, true);
                document.getElementById("datepickerParking").value = this.parking_processes.current_day_formatted;
            }

        },

        // function to submit personal-data form
        submitPersonalData() {
            if(this.checkSubmittedData()){
                // indicate loading
                this.trigger.loading = true;
                // set indicator that this is not for the email
                this.user_data.reseted_email = false;
                // create formdata for request 
                let data = this.getFormDataPersonalData()
                //execute request
                this.sendPersonalData(data, 'personal-data');        
                // finished loading
                this.trigger.loading = false;
            } else {
                this.invalid_submitted_data = true;
            }
        },

        // function to validate empty input fields from personal data
        checkSubmittedData(){
            if((this.user_info.street == null || this.user_info.street == "") &&
            (this.user_info.address_addition == null || this.user_info.address_addition == "") && 
            (this.user_info.phone == null || this.user_info.phone == "") &&
            (this.user_info.zip == null || this.user_info.zip == "") &&
            (this.user_info.city == null || this.user_info.city == "")) {
                return false;
            } else {
                return true;
            }
        },

        // function to validate email in personal data 
        submitPersonalDataEmail() {
            this.user_data.invalid_new_mail_response = null;
            
            if(this.user_data.new_mail != null){
                let validMail = /^\S+@\S+\.\S+$/;
                let mail = this.user_data.new_mail;

                if(validMail.test(mail)){
                    this.user_data.valid_mail = true;                    
                } else {
                    this.user_data.invalid_new_mail_response = "Keine gültige E-Mail-Adresse";
                }         
            } else {
                this.user_data.invalid_new_mail_response = "Bitte geben sie eine E-Mail Adresse an.";
            }
        },

        // function to reset personal form data
        resetPersonalDataForm(){
            this.set_user_data_response_message = null;
            this.user_data.new_mail = null;
            this.invalid_submitted_data = false;
            this.trigger.loading = true;
            this.fetchUserInfo();
            this.trigger.loading = false;
        },

        // function to double submit personal email adress change 
        finalSubmitPersonalDataEmail(trigger){
            if(trigger == "yes"){
                this.user_data.reseted_email = true;
                this.user_data.valid_mail = false;
                this.user_info.email = this.user_data.new_mail;
                this.trigger.loading = true;
                let formData = this.getFormDataPersonalData();
                this.sendPersonalData(formData, 'personal-data-email');
                this.trigger.loading = false;
            } else if(trigger == "cancel"){
                this.user_data.valid_mail = false;
            }
        },
        
        // function to convert object into formData for request
        getFormDataPersonalData(){
            let formData = new FormData();

            for ( let key in this.user_info ) {
                if(this.user_info[key] != null && this.user_info[key] != "" && key != "card" && key != "id"){
                    formData.append(key, this.user_info[key]);
                }                
            }
            return formData
        },

        // function to return form data of personal pin change 
        getFormDataPin(){
            let formData = new FormData();
            formData.append('pin_code', this.user_pin.new_pin);
            formData.append('secret', this.user_pin.old_pin);
            return formData;
        },

        // function to patch personal-data
        sendPersonalData(formData , triggerFunction) {
            let token = getRequestToken();            
            let header = token.sign({
                method: 'PATCH',
                'Content-Type': 'application/json',
                Accept : 'application/json',
                url: process.env.NEW_BACKEND_BASE_URL + "/apis/web/v1/profile"
            })
            // fetch with OAutch2
            fetch(header.url, {
                method: header.method,
                headers: header.headers,
                body: formData
            }).then(async response => {
                // reject not 200(HTTP-Statuscode) response
                if(!response.ok){                
                    this.set_user_data_response_message = "Es scheint etwas schief gelaufen zu sein. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
                    return Promise.reject(response)
                } else {
                    if(this.user_data.reseted_email){
                        this.set_user_data_response_message = "Eine E-Mail mit dem Aktivierungslink Ihrer neuen E-Mail-Adresse ist auf dem Weg zu Ihrem Postfach der neuen E-Mail-Adresse."
                    } else {
                        this.set_user_data_response_message = "Ihre Daten wurden erfolgreich geändert."
                    }
                }
                return response
            })
            // catch error response
            .catch(async response => {
                const error = await response
                return Promise.reject(error)
            })
            .catch(error => 
                // process error after unsuccessful fetch
                this.handleErrorResponse(error, triggerFunction)
            )
        },

        // function to prepare pin change 
        async sendIndividualPin() {
            this.resetUserPinForm();
            if(this.validatePinForm()){
                this.trigger.loading = true;
                this.fetchIndividualPin(this.getFormDataPin());
                this.$nextTick(() => {
                    let elem = document.getElementById("user-dashboard");
                    elem.scrollIntoView();
                })                
                this.trigger.loading = false;
            }
           
        },

        // function to validate personal pin 
        validatePinForm(){
            if(this.user_pin.old_pin === null) {
                this.user_pin.invalid_old_pin_response_message = "Bitte geben Sie Ihre alte PIN an.";
            } else if(this.user_pin.old_pin.length !== 4){
                this.user_pin.invalid_old_pin_response_message = "Ihre PIN ist nicht 4-stellig";
            }

            if (this.user_pin.new_pin === null) {
                this.user_pin.invalid_new_pin_response_message = "Bitte geben Sie eine neue PIN an.";
            } else if(this.user_pin.new_pin.length !== 4){
                this.user_pin.invalid_new_pin_response_message = "Ihre PIN ist nicht 4-stellig";
            }
            
            if(this.user_pin.new_repeated_pin === null){
                this.user_pin.invalid_new_repeated_pin_response_message = "Bitte wiederholen Sie Ihre neue PIN.";
            } else if(this.user_pin.new_repeated_pin.length !== 4){
                this.user_pin.invalid_new_repeated_pin_response_message = "Ihre PIN ist nicht 4-stellig";
            } else if(this.user_pin.new_pin !== this.user_pin.new_repeated_pin){
                this.user_pin.invalid_new_repeated_pin_response_message = "Die Wiederholte stimmt mit der neuen PIN nicht überein."
            }

            if(this.user_pin.invalid_old_pin_response_message === null &&
                this.user_pin.invalid_new_pin_response_message === null &&
                this.user_pin.invalid_new_repeated_pin_response_message === null){
                    return true;
                } else {
                    return false;
                }

        },

        // function to reset personal pin form 
        resetUserPinForm(){
            this.user_pin.invalid_old_pin_response_message = null;
            this.user_pin.invalid_new_pin_response_message = null;
            this.user_pin.invalid_new_repeated_pin_response_message = null;
        },

        // function to set user pin response message
        acceptPinResponse(){            
            this.user_pin.new_pin = null;
            this.user_pin.new_repeated_pin = null;
            if(this.set_user_pin_response_message == "Die von Ihnen angegebene ursprüngliche PIN ist nicht korrekt."){
                this.set_user_pin_response_message = null;                
            } else {
                this.set_user_pin_response_message = null;
                this.manageView('dashboard');
            }
            
        },

        // function to patch individual pin 
        fetchIndividualPin(formData) {
            let token = getRequestToken();            
            let header = token.sign({
                method: 'PATCH',
                'Content-Type': 'application/json',
                Accept : 'application/json',
                url: process.env.NEW_BACKEND_BASE_URL + "/apis/web/v1/profile/pin"
            })
            // fetch with OAutch2
            fetch(header.url, {
                method: header.method,
                headers: header.headers,
                body: formData
            }).then(async response => {
                // reject not 200(HTTP-Statuscode) response
                if(!response.ok){                
                    this.set_user_pin_response_message = "Es scheint etwas schief gelaufen zu sein. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
                    return Promise.reject(response)
                } else {
                    this.set_user_pin_response_message = "Ihre PIN wurde erfolgreich geändert."
                }
                return response
            })
            // catch error response
            .catch(async response => {
                const error = await response
                return Promise.reject(error)
            })
            .catch(error => 
                // process error after unsuccessful fetch
                this.handleErrorResponse(error, 'pin')
            )
        },
        
        // function to toggle sticky nav of transactions log
        handleScroll(){
            if(this.trigger.view == 'transactions' && this.transaction_data.current_day != null && this.$refs["stickyDateSelect"] != undefined) {
                let target = this.$refs["stickyDateSelect"];
                let origin = this.$refs["stickyDateSelectAnker"];
                let sibling = this.$refs["stickyAnkerEnd"];
                
                let top = target.getBoundingClientRect().top;
                let end = sibling.getBoundingClientRect().bottom;
                let height = target.getBoundingClientRect().height;

                if(top <= 85 && !target.classList.contains('sticky') && end > (height + 85)){
                    target.classList.add('sticky');                    
                } else if(target.classList.contains('sticky') && (origin.getBoundingClientRect().bottom > 85 || end <= (height + 85))) {
                    target.classList.remove('sticky');
                }

            } else if( this.trigger.view == 'parken-plus' && this.parking_processes.current_day != null && this.user_info.parking != undefined && this.$refs["stickyDateSelectParking"] != undefined) {
                let targetParking = this.$refs["stickyDateSelectParking"];
                let originParking = this.$refs["stickyDateSelectAnkerParking"];
                let siblingParking = this.$refs["stickyAnkerEndParking"];

                let top = targetParking.getBoundingClientRect().top;
                let end = siblingParking.getBoundingClientRect().bottom;
                let height = targetParking.getBoundingClientRect().height;

                if(top <= 85 && !targetParking.classList.contains('stick-parking') && end > (height + 85)){
                    targetParking.classList.add('stick-parking');                    
                } else if(targetParking.classList.contains('stick-parking') && (originParking.getBoundingClientRect().bottom > 85 || end <= (height + 85))) {
                    targetParking.classList.remove('stick-parking');
                }
                
            }
        },

        // function to fetch parking processes
        fetchParkingProcesses(){
            //get OAuth2 token
            let token = getRequestToken();            
            let header = token.sign({
                method: 'GET',
                url: process.env.NEW_BACKEND_BASE_URL + "/apis/web/v1/profile/parking_processes"
            })
            //fetch with OAuth2
            fetch(header.url, {
                method: header.method,
                headers: header.headers
            })
            .then(response => {
                //reject not 200(HTTP-Statuscode) response
                if(!response.ok){
                    return Promise.reject(response)
                }
                return response.json()
            })
            // catch error response
            .catch(async response => {
                const error = await response;
                this.trigger.loading = false;
                return Promise.reject(error);
                
            })
            .then(async json => {
                // process data after successful fetch
                this.trigger.refreshed_token = 0
                // some IDE's will critize this await (leave it)
                if(json.length > 0) {
                    await store.setDataParkingProcesses(json)
                    this.setStartVariablesParkingProcesses();                   
                } else {
                    this.trigger.loading = false;
                }            
            })
            .catch(error => 
                // process error after unsuccessful fetch
                this.handleErrorResponse(error, 'parking')
            )
        },

        // function to scroll parking info into view
        scrollToParkenContact(){
            let height = document.getElementById('kfz-banner-wrap');
            let top = $(window).scrollTop();            
            $('html, body').animate({ scrollTop: top + height.offsetHeight }, "slow")
        },

        // function to redirect to contact form of landingpage
        goToContact() {
            window.location.href="index.html#contact"
        }
    },
 
    mounted: function(){
        // redirect to index.html if no OAuth2-Token is present
        if(localStorage.getItem('ClientOAuth2Token') == null){
            window.location.href = "index.html";
        }
        
        if(localStorage.getItem('IndividualPinNotification') == null) {
            let body = $('#user-dashboard-body');
            let popUp = $('#popUpIndividualPin');
            let blur = $('#background-blur')
            body.scrollTop(0);
            body.addClass('no-scroll');
            blur.removeClass('donot-display')
            popUp.removeClass('donot-display');
            

        }
        // fetch base info of user
        this.fetchUserInfo();
    },
    created: function(){
        window.addEventListener('scroll', this.handleScroll);
    },    
    destroyed: function(){
        window.removeEventListener('scroll', this.handleScroll);
    }
})

// function for Collapsible List
let coll = document.getElementsByClassName("list-group-item");
let i;

for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
        this.classList.add('show');
        let content = this.nextElementSibling;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}

$('.dropdown-toggle').dropdown()

// function to detect redirect 
$('#user-dashboard').click(function(){
    if(localStorage.getItem('ClientOAuth2Token') == null){
        window.location.href = "login.html";
    };    
});

 // Back to top
 window.addEventListener('scroll', function() {
    if ($(this).scrollTop() >= 50) {
        $('#backToTop').fadeIn(200);
        $('.cookie-data').addClass('cookie-data-animation')
        $(".navbar-style-dark").find(".navbar").addClass("nav-solid");

    } else {
        $('#BackToTop').fadeOut(200);
        $('.cookie-data').removeClass('cookie-data-animation')
        $(".navbar-style-dark").find(".navbar").removeClass("nav-solid");
    }
});

$('#popUpLink').click(function(){
    closePopUp();
    $('#dashboardPinPage').click()
})

$('#popUpButton').click(function() {
    closePopUp();
});

function closePopUp(){
    localStorage.setItem('IndividualPinNotification', true);
    
    let body = $('#user-dashboard-body');
    let popUp = $('#popUpIndividualPin');
    let blur = $('#background-blur')
    
    
    body.removeClass('no-scroll');
    blur.addClass('donot-display')
    popUp.addClass('donot-display');
    
}

$('#backToTop').click(function() {
    $('body,html').animate({
        scrollTop: 0
    }, 500);
});

$('#cookie-bot-btn').unbind('click');
$('#cookie-bot-btn').click(function() {
    $('#cookie-data-wrap').toggleClass('donot-display');
});